import { I } from '@angular/cdk/keycodes';
import { LowerCasePipe, NgClass } from '@angular/common';
import { Component, input, Input } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { environment } from 'src/_environments/environment';
import { RecipeIngredient } from 'src/_model/recipe';

@Component({
  selector: 'app-ingredientlist',

  templateUrl: './ingredientlist.component.html',
  styleUrl: './ingredientlist.component.scss',
  imports: [
    NgClass,
    LowerCasePipe,
    TranslateModule,
  ],
})
export class IngredientlistComponent {
  _env = environment
  hasAddYourself = false;

  private _personsoptions: number[] = environment.subscriptionPersonChoices;
  @Input() set personsoptions(value: number[]) {
    this._personsoptions = value;
  }  
  get personsoptions() {
    return this._personsoptions
  }

  @Input() personquantity: number = this._env.personCountDefault
  @Input() doublepersons: boolean = false;

  private _ingredients: RecipeIngredient[] | any[]
  @Input() set ingredients(value: RecipeIngredient[] | any[]) {
    this._ingredients = value;
    if (value)
      this.hasAddYourself = value.filter(f => f.provided !== undefined && f.provided === false).length > 0
  }
  get ingredients() {
    return this._ingredients;
  }

  constructor(
    private _translate: TranslateService,

  ) {

  }

  getIngredientQuantity(ingredient: RecipeIngredient) {
    let qty;
    switch (this.personquantity) {
      case 1:
        qty = ingredient.onepersquantity;
        break;
      case 2:
        qty = ingredient.twopersquantity;
        break;
      case 3:
        qty = ingredient.threepersquantity;
        break;
      case 4:
        qty = ingredient.fourpersquantity;
        break;
      default:
        qty = ingredient.twopersquantity;
        break;
    }
    return qty > 0 ? qty : '';
  }

}
